import { clienteCadastroProspect, clienteCadastroCliente, clienteCadastroBaixado, clienteCadastroOutros } from '../cadastro/cliente-cadastro';

/** Situações do cliente */
export interface ClienteSituacao {
    id: number;
    nome: string;
    color: string;
    badge: string;
    cadastros: number[];
}

export const clienteSituacaoNovo: ClienteSituacao = {
    id: 2,
    nome: 'Novo',
    color: '#a79c55',
    badge: 'badge badge-cliente-situacao-novo',
    cadastros: [clienteCadastroProspect.id, clienteCadastroCliente.id]
};
export const clienteSituacaoPositivo: ClienteSituacao = {
    id: 3,
    nome: 'Positivo',
    color: '#499466',
    badge: 'badge badge-cliente-situacao-positivo',
    cadastros: [clienteCadastroCliente.id]
};
export const clienteSituacaoAtivo: ClienteSituacao = {
    id: 4,
    nome: 'Ativo',
    color: '#20b75d',
    badge: 'badge badge-cliente-situacao-ativo',
    cadastros: [clienteCadastroProspect.id, clienteCadastroCliente.id]
};
export const clienteSituacaoPreInativo: ClienteSituacao = {
    id: 5,
    nome: 'Pré-Inativo',
    color: '#ffa500',
    badge: 'badge badge-cliente-situacao-preinativo',
    cadastros: [clienteCadastroProspect.id, clienteCadastroCliente.id]
};
export const clienteSituacaoInativo: ClienteSituacao = {
    id: 6,
    nome: 'Inativo',
    color: '#f55e59',
    badge: 'badge badge-cliente-situacao-inativo',
    cadastros: [clienteCadastroProspect.id, clienteCadastroCliente.id]
};
export const clienteSituacaoBloqueado: ClienteSituacao = {
    id: 7,
    nome: 'Bloqueado',
    color: '#d08e16',
    badge: 'badge badge-cliente-situacao-bloqueado',
    cadastros: [clienteCadastroCliente.id]
};
export const clienteSituacaoPreBaixado: ClienteSituacao = {
    id: 8,
    nome: 'Pré-Baixado',
    color: '#ab59f5',
    badge: 'badge badge-cliente-situacao-prebaixado',
    cadastros: [clienteCadastroBaixado.id]
};
export const clienteSituacaoBaixado: ClienteSituacao = {
    id: 9,
    nome: 'Baixado',
    color: '#f55e59',
    badge: 'badge badge-cliente-situacao-baixado',
    cadastros: [clienteCadastroBaixado.id]
};
export const clienteSituacaoCongelado: ClienteSituacao = {
    id: 10,
    nome: 'Congelado',
    color: '#2d9bf0',
    badge: 'badge badge-cliente-situacao-congelado',
    cadastros: [clienteCadastroCliente.id]
};
export const clienteSituacaoOutros: ClienteSituacao = {
    id: 99,
    nome: 'Outros',
    color: '#565656',
    badge: 'badge badge-cliente-situacao-outros',
    cadastros: [clienteCadastroOutros.id]
};


export const clienteSituacoes: ClienteSituacao[] = [
    clienteSituacaoNovo,
    clienteSituacaoPositivo,
    clienteSituacaoAtivo,
    clienteSituacaoPreInativo,
    clienteSituacaoInativo,
    clienteSituacaoCongelado,
    clienteSituacaoBloqueado,
    clienteSituacaoPreBaixado,
    clienteSituacaoBaixado,
    clienteSituacaoOutros
];

/** Verifica se a situação do cliente é igual a Novo */
export function isClienteSituacaoNovo(situacao: number): boolean {
    return situacao === clienteSituacaoNovo.id;
}

/** Verifica se a situação do cliente é igual a Positivo */
export function isClienteSituacaoPositivo(situacao: number): boolean {
    return situacao === clienteSituacaoPositivo.id;
}


/** Verifica se a situação do cliente é igual a Ativo */
export function isClienteSituacaoAtivo(situacao: number): boolean {
    return situacao === clienteSituacaoAtivo.id;
}

/** Verifica se a situação do cliente é igual a PreInativo */
export function isClienteSituacaoPreInativo(situacao: number): boolean {
    return situacao === clienteSituacaoPreInativo.id;
}

/** Verifica se a situação do cliente é igual a Inativo */
export function isClienteSituacaoInativo(situacao: number): boolean {
    return situacao === clienteSituacaoInativo.id;
}

/** Verifica se a situação do cliente é igual a Bloqueado */
export function isClienteSituacaoBloqueado(situacao: number): boolean {
    return situacao === clienteSituacaoBloqueado.id;
}

/** Verifica se a situação do cliente é igual a PreBaixado */
export function isClienteSituacaoPreBaixado(situacao: number): boolean {
    return situacao === clienteSituacaoPreBaixado.id;
}

/** Verifica se a situação do cliente é igual a Baixado */
export function isClienteSituacaoBaixado(situacao: number): boolean {
    return situacao === clienteSituacaoBaixado.id;
}

/** Verifica se a situação do cliente é igual a Congelado */
export function isClienteSituacaoCongelado(situacao: number): boolean {
    return situacao === clienteSituacaoCongelado.id;
}

/** Verifica se a situação do cliente é igual a Outros */
export function isClienteSituacaoOutros(situacao: number): boolean {
    return situacao === clienteSituacaoOutros.id;
}
